import { render, staticRenderFns } from "./NaVerticalslot.vue?vue&type=template&id=694d5d1f&scoped=true"
import script from "./NaVerticalslot.vue?vue&type=script&lang=js"
export * from "./NaVerticalslot.vue?vue&type=script&lang=js"
import style0 from "./NaVerticalslot.vue?vue&type=style&index=0&id=694d5d1f&prod&lang=less"
import style1 from "./NaVerticalslot.vue?vue&type=style&index=1&id=694d5d1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694d5d1f",
  null
  
)

export default component.exports